import { lazy } from 'react';

/** Inclusões especiais por rotina, carregadas apenas ao abrir /novo. */
export const inclusaoRotina = {
  FIS120: lazy(() => import('../../modulos/FIS/IncluirManualEntrada').then((m) => ({ default: m.DialogoIncluirManualEntrada }))),
};
